import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  // Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  LinearProgress,
  Button,
  IconButton, 
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IsNoU } from 'common/utils';

//import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const CampaignTable = props => {
  const { 
    className, 
    userRole,
    campaigns, 

    onClickOpenRegisterDialog,
    onClickOpenDeleteDialog,
    onClickOpenReserveDialog,
    disableDeleteButton,
    disableReserveButton,

    onSetSelectedCampaigns,
    onClickEditDeployedCampaign,
    onClickEditReservedCampaign,
    onClickPreviewCampaign,

    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest } = props;

  const classes = useStyles();

  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {
    const { campaigns } = props;

    let selectedCampaigns;

    if (event.target.checked) {
      selectedCampaigns = campaigns.map(campaign => campaign.id);
    } else {
      selectedCampaigns = [];
    }

    setSelectedCampaigns(selectedCampaigns);
    onSetSelectedCampaigns(selectedCampaigns);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedCampaigns.indexOf(id);
    let newSelectedCampaigns = [];

    if (selectedIndex === -1) {
      newSelectedCampaigns = newSelectedCampaigns.concat(selectedCampaigns, id);
    } else if (selectedIndex === 0) {
      newSelectedCampaigns = newSelectedCampaigns.concat(selectedCampaigns.slice(1));
    } else if (selectedIndex === selectedCampaigns.length - 1) {
      newSelectedCampaigns = newSelectedCampaigns.concat(selectedCampaigns.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedCampaigns = newSelectedCampaigns.concat(
        selectedCampaigns.slice(0, selectedIndex),
        selectedCampaigns.slice(selectedIndex + 1)
      );
    }

    setSelectedCampaigns(newSelectedCampaigns);
    onSetSelectedCampaigns(newSelectedCampaigns);
  };

  return (
    <div>

      {userRole !== 'user' && (
        <div className={classes.row}>
          <Button
            color="primary"
            variant="contained"
            onClick={ onClickOpenRegisterDialog }
          >
            등록
          </Button>

          <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
            variant="contained"
            disabled={ disableDeleteButton }
            onClick={ onClickOpenDeleteDialog }
          >
            삭제
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={ disableReserveButton }
            onClick={ onClickOpenReserveDialog }
          >
            예약배포지정
          </Button>
        </div>
      )}

      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {openProgress && <LinearProgress /> }
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={campaigns.length > 0 && selectedCampaigns.length === campaigns.length}
                        color="primary"
                        indeterminate={
                          selectedCampaigns.length > 0 &&
                          selectedCampaigns.length < campaigns.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>번호</TableCell>
                    <TableCell>캠페인명</TableCell>
                    <TableCell>권역</TableCell>
                    <TableCell>그룹</TableCell>
                    <TableCell>현재배포일시</TableCell>
                    <TableCell>예약배포일시</TableCell>
                    <TableCell>현재배포</TableCell>
                    <TableCell>예약배포</TableCell>
                    <TableCell>보기</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {campaigns.slice(0, rowsPerPage).map((campaign, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={campaign.id}
                      selected={selectedCampaigns.indexOf(campaign.id) !== -1}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedCampaigns.indexOf(campaign.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, campaign.id)}
                          value="true"
                        />
                      </TableCell>
                      <TableCell>{index}</TableCell>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          <Typography variant="body1">{campaign.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{campaign.area}</TableCell>
                      <TableCell>{campaign.group}</TableCell>
                      <TableCell>
                        {!IsNoU(campaign.deployed_at) && IsNoU(campaign.reserved_at) ? 
                          moment(campaign.deployed_at).format('YYYY-MM-DD') : '' }
                      </TableCell>
                      <TableCell>
                        {IsNoU(campaign.reserved_at) ? '' : moment(campaign.reserved_at).format('YYYY-MM-DD')}
                      </TableCell>
                      <TableCell> 
                        {userRole !== 'user' && !IsNoU(campaign.deployed_at) && IsNoU(campaign.reserved_at) && (
                          <IconButton 
                            arai-label="view"
                            onClick={() => { onClickEditDeployedCampaign(campaign) }} >
                            <EditIcon /> 
                          </IconButton>
                      )}
                      </TableCell>
                      <TableCell> 
                        {userRole !== 'user' && !IsNoU(campaign.reserved_at) && (
                          <IconButton 
                            arai-label="view"
                            onClick={() => { onClickEditReservedCampaign(campaign) }} >
                            <EditIcon /> 
                          </IconButton>
                        )}
                      </TableCell>
                      <TableCell> 
                        <IconButton 
                          arai-label="view"
                          onClick={() => { onClickPreviewCampaign(campaign) }} >
                          <VisibilityIcon /> 
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </PerfectScrollbar>
        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            labelRowsPerPage=''
            component="div"
            count={item_total}
            onChangePage={onPageChange}
            onChangeRowsPerPage={onRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>
    </div>
  );
};

CampaignTable.propTypes = {
  className: PropTypes.string,
  campaigns: PropTypes.array.isRequired
};

export default CampaignTable;
